import React, { useState, useEffect } from 'react';
import apiClient from "../../../api/apiClient";
import { publish, subscribe, unsubscribe } from '../../../utils/pubsubWrapper';
import { Table, Form, InputGroup, Container, Row, Col, Button, Pagination } from 'react-bootstrap';
import { MediaPlayer, PopupModel, AlertMassage, ShowMoreText } from '../../shared';
import { getTags, formatDate, checkVideoPath, scrollToTop } from '../../../utils/utils';

import { DeleteIcon, EditIcon, VideoPlayIcon } from '../../../utils/FontIcon';
import { VIDEOS } from '../../../utils/ApiEndPoint';

const VideoList = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [videos, setVideos] = useState([]);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [popupData, setPopupData] = useState({
    show: false,
    title: '',
    type: '',
    selectedItem: {},
  });
  const [showAlert, setShowAlert] = useState({
    type: '',
    title: '',
    msg: ``,
    show: false

  });

  useEffect(() => {
    fetchVideos();
  }, []);
  useEffect(() => {
    const pubsubToken = subscribe('FETCH_VIDEO', () => {
      fetchVideos();
    });
    return () => unsubscribe(pubsubToken);
  }, []);
  const fetchVideos = async () => {
    setLoading(true)
    let tempAlert = {
      type: 'danger',
      title: 'Error',
      msg: '',
      show: true
    }
    apiClient.get(VIDEOS)
      .then((response) => {
        if (response.status === 200) {
          setVideos(response.data);
        } else {
          setError('Failed to load videos');
          tempAlert.msg = 'Failed to load videos';
          setShowAlert(tempAlert);
        }
      }).catch((error) => {
        setError('Failed to load videos');
        tempAlert.msg = 'Failed to load videos';
        setShowAlert(tempAlert);

      }).finally(() => {
        setLoading(false);
      });
  };
  const handleOpenModal = (video) => {
    setPopupData({
      show: true,
      title: video.title,
      type: 'video',
      selectedItem: video,
    })
  };
  const handleCloseModal = () => {
    setPopupData({
      show: false,
      title: '',
      type: '',
      selectedItem: {},
    })
  };
  const handelAction = async (e, actionType, item) => {
    switch (actionType) {
      case 'edit':
        publish('EDIT_VIDEO', item);
        scrollToTop();
        break;
      case 'delete':
        setPopupData({
          show: true,
          title: 'Confirm!',
          type: 'confirm',
          selectedItem: item,
        })
        break;
    }
  }

  const handelDelete = async () => {
    const data = {
      "deletedBy": popupData.selectedItem?.createdBy,
    }
    const id = popupData.selectedItem?._id;
    const title = popupData.selectedItem?.title;
    let tempAlert = {
      type: 'danger',
      title: 'Error',
      msg: '',
      show: true
    }
    apiClient.patch(`${VIDEOS}/${id}/soft-delete`, data)
      .then((response) => {
        if (response.status === 200) {
          tempAlert.type = 'success';
          tempAlert.title = 'success';
          tempAlert.msg = `${title} is deleted successfully`;
          setShowAlert(tempAlert);
          fetchVideos();
        } else {
          tempAlert.msg = `Failed to delete ${title} videos`;
          setShowAlert(tempAlert);
        }
      }).catch((error) => {
        tempAlert.msg = `Failed to delete ${title} videos ${JSON.stringify(error)}`;
        setShowAlert(tempAlert);
      }).finally(() => {
        handleCloseModal();
      });
  }
  const hideAlert = () => {
    setShowAlert({
      type: '',
      title: '',
      msg: '',
      show: false
    })
  }
  const filteredVideos = videos.filter(video => {
    const searchLower = search.toLowerCase();
    return (
      video?.title?.toLowerCase().includes(searchLower) ||
      (Array.isArray(video.tags) ? video.tags.join(' ').toLowerCase() : '').includes(searchLower)
    );
  });

  const paginatedVideos = filteredVideos.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const totalPages = Math.ceil(filteredVideos.length / pageSize);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  if (loading) return <p className='p-2 w-100 text-center m-3 bg-light'>Loading videos...</p>;
  if (error) return <p className='p-2 w-100 text-center m-3 bg-light'>{error}</p>;
  return (
    <Container fluid className="mt-2 px-4">
      <Row className="justify-content-between align-items-center mb-1">
        <Col md={6}>
          <h6 className='fw-700'>Existing Video List</h6>
        </Col>
        <Col md={4} className='p-relative'>
          <InputGroup>
            <Form.Control
              placeholder="Search courses..."
              type='search'
              value={search}
              onChange={e => setSearch(e.target.value)}
              className='searchbox-input'
            />
          </InputGroup>
          <span className='search-icon2'></span>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Table responsive className='mytable'>
            <thead >
              <tr>
                <th scope="col" className='txt-center'>S.No.</th>
                <th scope="col" style={{ width: '50%' }}>Title</th>
                <th scope="col" className='text-nowrap'>Created at</th>
                <th scope="col" className='text-nowrap'>Created by</th>
                <th scope="col" className='text-nowrap'>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedVideos.map((video, idx) => {
                return <tr key={idx + (currentPage - 1) * pageSize}>
                  <td className='txt-center'>
                    {(currentPage - 1) * pageSize + idx + 1}
                  </td>
                  <td style={{ maxWidth: '120px' }}>
                    <Row>
                      <Col xs={2}>
                        <a
                          href="#"
                          onClick={e => {
                            e.preventDefault();
                            handleOpenModal(video);
                          }}
                          title={checkVideoPath(video.videoUrl) ? video.title : 'Video will shown in sometime'}
                          style={{ cursor: 'pointer', position: 'relative', display: 'flex', gap: '10px', textDecoration: 'none' }}
                        >
                          {checkVideoPath(video.videoUrl) ?
                            <span className='p-relative small-thumb-list'>
                              <img src={video.thumbnailUrl} alt={video.title} className='img-fluid video-thumnail' />
                              <VideoPlayIcon className='video-playbtn'/>
                            </span>
                            :
                            <span className='p-relative small-thumb-list'>
                              <img src='/lms/img/defaultthumb.jpg' alt={video.title} className='img-fluid video-thumnail' style={{ cursor: 'not-allowed' }} />
                            </span>
                          }
                        </a>
                      </Col>
                      <Col xs={10}>
                        <span className='d-block'><span className='inline-block' style={{ fontSize: '0.75rem', fontWeight: '500' }}>Title :</span><span className='inline-block subhead-txt' > {video.title}</span></span>
                        <span className='d-block'><span className='inline-block' style={{ fontSize: '0.75rem', fontWeight: '500' }}>Keywords - </span><span className='inline-block subhead-txt' >{video.tags && video.tags.length ? getTags(video.tags) : ''}</span></span>
                        <span className='d-block'><span className='inline-block' style={{ fontSize: '0.75rem', fontWeight: '500' }}>Size - </span><span className='inline-block subhead-txt' >{video?.size ? `${video.size} mb` : 'Not Available'}</span></span>
                        <span className='d-block'><span className='inline-block' style={{ fontSize: '0.75rem', fontWeight: '500' }}>Description -</span><ShowMoreText text={video.description} styleClass='inline-block subhead-txt'/></span>
                      </Col>
                    </Row>
                  </td>
                  <td>{formatDate(video.createdAt)}</td>
                  <td>{video.createdBy ? video.createdBy : ''}</td>
                  <td>
                    <div style={{ display: 'flex', paddingBlock: '1rem' }}>
                      <a
                        style={{ cursor: 'pointer', marginLeft: '10px', marginRight: '10px' }}
                        onClick={(e) => handelAction(e, 'edit', video)}
                        title={'Edit'}>
                        <EditIcon />
                      </a>
                      <a
                        style={{ cursor: 'pointer', marginLeft: '10px', marginRight: '10px' }}
                        onClick={(e) => handelAction(e, 'delete', video)}
                        title={'Delete'}><DeleteIcon />
                      </a>
                    </div>
                  </td>
                </tr>
              })}
            </tbody>
          </Table></Col>
        <Col lg={12}>
          <div className="d-flex justify-content-center">
            <Pagination className='mypagination-listing'>
              <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
              <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
              {[...Array(totalPages)].map((_, idx) => (
                <Pagination.Item
                  key={idx + 1}
                  active={currentPage === idx + 1}
                  onClick={() => handlePageChange(idx + 1)}
                >
                  {idx + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
              <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
            </Pagination>
          </div></Col>
      </Row>
      {popupData.show && popupData.type === 'video' ?
        <PopupModel
          size='lg'
          showModal={popupData.show}
          handleCloseModal={handleCloseModal}
          title={popupData.title}
          type={popupData.type}
        >
          {popupData.selectedItem && (
            <>
              <Row>
                <Col lg={12}>
                  <MediaPlayer vidUrl={popupData.selectedItem._id} width={'100%'} height={'460'} />
                </Col>

              </Row>
              <Row style={{
                border: '1px solid #dbdbdb',
                lineHeight: '2.4rem',
                width: '100%',
                margin: '0 auto'
              }}>
                <Col lg={2}><strong>Description:</strong></Col>
                <Col lg={10}>{popupData.selectedItem.description}</Col>
                <hr style={{ margin: '2px' }} />
                <Col lg={2}><strong>Tags:</strong></Col>
                <Col lg={10}>{getTags(popupData.selectedItem.tags)}</Col>
              </Row>
            </>
          )}
        </PopupModel> : null
      }
      {popupData.show && popupData.type === 'confirm' ?
        <PopupModel
          size='md'
          showModal={popupData.show}
          handleCloseModal={handleCloseModal}
          title={popupData.title}
          type={popupData.type}
          footerContent={
            <>
              <Button variant="danger" onClick={handelDelete}>Yes</Button>
              <Button variant="info" onClick={handleCloseModal}>No</Button>
            </>
          }
        >
          <p>Are you sure you want to delete <strong>{popupData.selectedItem.title}</strong> ? This action cannot be undone.</p>
        </PopupModel> : null}

      {showAlert.show &&
        <AlertMassage
          show={showAlert.show}
          type={showAlert.type}
          title={showAlert.title}
          massage={showAlert.msg}
          hideAlert={hideAlert} />
      }

    </Container>
  );
};

export default VideoList;